import { JSX, useEffect, useState } from 'react';
import { TodoTask } from '../todolist/add-todo/addTodoList';
import TodoDate from '../todolist/todoDate/date';
import BinIcon from '../assets/images/svgs/bin--Streamline-Pixel.svg';
import editIcon from '../assets/images/icons/hand-ok--Streamline-Pixel.png';
import './note-todo-view.css';

interface NoteTodoProps {
    todo: TodoTask;
    editTitle: (newTitle: string) => void;
    deleteTodo: () => void;
    saveTodo: (todo: TodoTask) => void;
    newTodo: boolean;
};

const NoteTodoView = ({ todo, editTitle, deleteTodo, saveTodo, newTodo = false }: NoteTodoProps) : JSX.Element => {
    const [titleInput, setTitleInput] = useState(todo.title);

    const handleSaveTitle = () => {
        editTitle(titleInput);
        //setIsEditTitle(false);
    };

    useEffect(() => {
        editTitle(titleInput);
    },[titleInput]);

    return (
        <div className='todo-task-container'>
            <div className='todo-task-view'>
                <div className='todo-task-content-outter'>
                    <div className='todo-task-content'>
                        <input 
                                className='todo-task-title-input-container' 
                                value={titleInput} 
                                onChange={(e) => setTitleInput(e.target.value)}
                                onKeyDown={(e) => e.key === 'Enter' && editTitle(titleInput)}
                            />
                            <div className='right-align-container'>
                                <TodoDate dateFormat={'MMM dd'} date={todo.date} onTodoDateChange={() => {}}/>
                            </div>
                        </div>
                    <div className="todoView-bottom-line"/>
                </div>
                {newTodo? (
                    <img 
                    className='todo-task-category-img' 
                    src={editIcon} 
                    onClick={() => saveTodo(todo)}/>
                ) : (
                    <img src={BinIcon} className='todo-task-category-img' onClick={deleteTodo}/>)
                }
            </div>
        </div>
    );
}

export default NoteTodoView;